// dots plugin
// $('#elem').dots();
  (function($){$.fn.extend({dots:function(o){var a=0,b=this,s=$.extend({time:600,dots:3}, o);c=function(){if(a<s.dots){b.append('.');a++;}else{b.html('');a=0;}};setInterval(c,s.time);}})}(jQuery));
define("dots", ["jquery"], function(){});

